import { Component, OnInit } from '@angular/core';
import { LogService } from '../../../services/log.service';
import { AdminService } from '../../../services/admin.service';
import { SessionService } from '../../../services/session.service';
import { ErrorsDialogComponent } from '../../errors-dialog/errors-dialog.component';
import { ErrorsDialogService } from '../../../services/errors-dialog.service';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {
  constructor(
    private log: LogService,
    public admin: AdminService,
    private session: SessionService,
    private errorsDialog: ErrorsDialogService
  ) {}

  ngOnInit() {
    //    this.log.trace('admin home loaded');
    if (this.admin.isDevMode()) {
      // const errors = [];
      // errors.push('some validation error');
      // errors.push('another validation error');
      // errors.push('oops, something else happened');
      // this.errorsDialog.open(errors);
    }
  }

  onUserSelected(username) {
    this.log.trace('user selected callback in admin', username);
  }
}
